import React from "react";
import { cls } from "@wss/cls";
import formatAsCurrency from "@wss/utilities/formatAsCurrency";
import CreditKeyBanner from "../CreditKey/CreditKeyBanner";
import DivideByUnitPrice from "./DivideByUnitPrice";
import SaleBadgeAndPricing from "~/common/SaleBadgeAndPricing";
interface DisplaySalePriceProps {
  price: number;
  priceLabel: string;
  salePrice: number;
  unitOfMeasure: string;
  divideByUnit?: string;
  divideQuantity?: number;
  showCreditKey?: boolean;
  showCrossoutPrice?: boolean;
  salePricingClassNames?: string;
  saleBadgeExtraClassNames?: string;
  regularPricingClassNames?: string;
  salePriceWithQuantityDiscounts?: boolean;
  cssClass: string;
}
const DisplaySalePrice = ({
  price,
  priceLabel,
  salePrice,
  unitOfMeasure,
  divideByUnit,
  divideQuantity,
  showCreditKey = true,
  showCrossoutPrice = false,
  regularPricingClassNames = "",
  salePricingClassNames = "",
  saleBadgeExtraClassNames = "",
  salePriceWithQuantityDiscounts = false,
  cssClass
}: DisplaySalePriceProps) => {
  const renderDivideByUnitPrice = () => {
    if (!divideByUnit || divideByUnit?.length === 0) {
      return <></>;
    }
    if (!divideQuantity || divideQuantity <= 0) {
      return <></>;
    }
    return <DivideByUnitPrice divideByUnit={divideByUnit} divideQuantity={divideQuantity} price={salePrice} cssClass={cssClass} data-sentry-element="DivideByUnitPrice" data-sentry-component="renderDivideByUnitPrice" data-sentry-source-file="DisplaySalePrice.tsx" />;
  };
  const displayPriceLabel = priceLabel.length > 0;
  return <>
      {!salePriceWithQuantityDiscounts ? <SaleBadgeAndPricing price={price} displayPriceLabel={displayPriceLabel} priceLabel={priceLabel} dataTestId="was-price" salePricingClassNames={salePricingClassNames} saleBadgeExtraClassNames={saleBadgeExtraClassNames} /> : <p data-testid="was-price" className={cls(salePricingClassNames)}>
          <span className={cls("text-black", "font-bold", "bg-yellow-400", "rounded-sm", "antialiased", saleBadgeExtraClassNames)}>
            Sale
          </span>
          <span aria-hidden="true">reg</span>&nbsp;
          {displayPriceLabel ? priceLabel : formatAsCurrency.formatIfUndefined(price)}
          <span className="sr-only">
            now{" "}
            {`${formatAsCurrency.formatIfUndefined(salePrice)}/${unitOfMeasure}`}
          </span>
        </p>}
      <p className={regularPricingClassNames}>
        {formatAsCurrency.formatIfUndefined(salePrice)}
        {unitOfMeasure && <span className="each pr-1">{`/${unitOfMeasure}`}</span>}
        {renderDivideByUnitPrice()}
      </p>
      {showCreditKey && !showCrossoutPrice && <CreditKeyBanner price={salePrice} />}
    </>;
};
export default DisplaySalePrice;